import { type TypedDocumentNode, gql } from '@apollo/client';

import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { useQuery } from '@sorare/core/src/hooks/graphql/useQuery';

import { ScheduledPlayerGameScoreState } from '@sorare/marketplace/src/components/game/ScheduledPlayerGameScoreState';
import { Grade } from '@sorare/marketplace/src/components/player/Grade';

import type {
  ProjectionInGameHeaderQuery,
  ProjectionInGameHeaderQueryVariables,
} from './__generated__/index.graphql';

const PROJECTION_IN_GAME_HEADER_QUERY = gql`
  query ProjectionInGameHeaderQuery($gameId: ID!, $playerSlug: String!) {
    anyGame(id: $gameId) {
      id
      playerGameScore(playerSlug: $playerSlug) {
        id
        projection {
          id
          ...Grade_playerGameScoreProjection
        }
        ...ScheduledPlayerGameScoreState_playerGameScore
      }
    }
  }
  ${ScheduledPlayerGameScoreState.fragments.playerGameScore}
  ${Grade.fragments.projection}
` as TypedDocumentNode<
  ProjectionInGameHeaderQuery,
  ProjectionInGameHeaderQueryVariables
>;

type Props = {
  anyGameId: string;
  playerSlug: string;
};
export const PlayerProjectionInGameHeader = ({
  anyGameId,
  playerSlug,
}: Props) => {
  const { data } = useQuery(PROJECTION_IN_GAME_HEADER_QUERY, {
    variables: {
      gameId: anyGameId,
      playerSlug,
    },
  });

  const { anyGame } = data || {};

  if (!anyGame?.playerGameScore?.projection) {
    return null;
  }

  return (
    <Horizontal>
      <ScheduledPlayerGameScoreState
        variant="text"
        playerGameScores={[anyGame.playerGameScore]}
        includesIcon
      />
      <Grade projection={anyGame.playerGameScore.projection} />
    </Horizontal>
  );
};
